export type TrackCode =
  | 'semi-skilled'
  | 'trades'
  | 'middle-tier'
  | 'upper-tier'
  | 'top-tier'
  | 'entrepreneurship';

/** Track codes excluding entrepreneurship — used where only standard career tracks apply */
export type StandardTrackCode = Exclude<TrackCode, 'entrepreneurship'>;

export function isStandardTrack(code: TrackCode): code is StandardTrackCode {
  return code !== 'entrepreneurship';
}

export const TRACK_CODE_ORDER: readonly TrackCode[] = [
  'semi-skilled',
  'trades',
  'middle-tier',
  'upper-tier',
  'top-tier',
] as const;

export type CareerTrack = Readonly<{
  id: number;
  name: string;
  code: TrackCode;
  description?: string;
  media_url?: string;
}>;
